/*
 * 使用不同参数实现业务需求，参数判断放置于meta字段中
 * @scrollTop: 记录滚动高度，true为不记录，false为记录
 * @title: header组件中 title显示内容
 * @isHideHeader: 头部是否隐藏
 * @needLogin: 页面是否需要登录
 */
import Vue from 'vue'
import Router from 'vue-router'
import Storage from '@/utils/Storage'
import { getCookie } from '@/utils/tools'
import store from '@/store'
import wxApi from '@/utils/wxAuth'
import { http } from '@/utils/http'

import Index from '@/pages/home/index'
import Home from '@/pages/home/components/home'
import Activity from '@/pages/home/components/activity'
import Message from '@/pages/home/components/message'
// 我的账号页
import Account from '@/pages/home/components/account'
// 红娘套餐页
import Combo from '@/pages/combo'
// 个人主页
import PersonInfo from '@/pages/personInfo'
// 活动主页
import ActivityInfo from '@/pages/activityInfo'
// IOS虚拟币充值
import Coin from '@/pages/coin'
// 活动差价列表
import GapPrice from '@/pages/gapPrice'
// 用户协议页
import UserDeal from '@/pages/userDeal'
// 用户须知
import Agreement from '@/pages/userDeal/agreement'
// 关于我们
import AboutUs from '@/pages/userDeal/aboutUs'
// 我喜欢的人
import Like from '@/pages/personList/like'
// 喜欢我的人
import LikeMe from '@/pages/personList/likeMe'
// 我关注的人
import Follow from '@/pages/personList/follow'
// 我索要微信的人
import Ask from '@/pages/personList/ask'
// 消息详情页
import MessageDetail from '@/pages/messageDetail'
// 客服页
import CustomerService from '@/pages/customerService'
// 设置页
import Setting from '@/pages/setting'
// 基础资料页
import BaseInfo from '@/pages/baseInfo'
// 修改基础资料页
import DisplayInfo from '@/pages/baseInfo/display'

// 设置基本资料页
import SetUserData from '@/pages/setUserData'
// 设置性别页
import SetSex from '@/pages/setUserData/components/setSex'
// 设置学历页
import SetEducation from '@/pages/setUserData/components/setEducation'
// 设置生日页
import SetBirthday from '@/pages/setUserData/components/setBirthday'
// 设置生日页
import SetTall from '@/pages/setUserData/components/setTall'
import SetPhone from '@/pages/setUserData/components/setPhone'
// 交易记录页
import Transcation from '@/pages/setting/transcation'
// 喜欢明细页
import LikeDetail from '@/pages/setting/likeDetail'
// 上传身份证
import UploadCert from '@/pages/Auth/uploadCert'
// 上传身份证
import UploadEducation from '@/pages/Auth/uploadEducation'
// 上传身份证
import UploadCareer from '@/pages/Auth/uploadCareer'
// 404页
import NotFound from '@/pages/NotFound'
// 测试页
import Test from '@/pages/test'

// 404页
import FakeIndex from '@/pages/fake/index'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    let position = null
    // 如果有保存滚动位置，直接让页面滚动至指定位置
    if (savedPosition) {
      position = savedPosition
    } else {
      // 没有返回滚动距离时，判断meta是否有几率滚动距离，有则设置滚动距离
      // 判断是否需要记录滚动位置
      if (to.meta.scrollTop === false) {
        position = { x: 0, y: to.meta.scrollHeight }
      } else {
        position = { x: 0, y: 0 }
      }
    }
    return position
  },
  routes: [
    {
      name: '',
      path: '',
      component: Index,
      children: [
        {
          name: 'Home',
          path: '/',
          alias: '/index.html',
          component: Home,
          meta: {
            isHideHeader: true
          }
        },
        {
          name: 'Activity',
          path: '/activitys.html',
          component: Activity,
          meta: {
            isHideHeader: true
          }
        },
        {
          name: 'Messages',
          path: '/messages.html',
          component: Message,
          meta: {
            isHideHeader: true
          }
        },
        {
          name: 'Account',
          path: '/account.html',
          component: Account,
          meta: {
            isHideHeader: true
          }
        }
      ]
    },
    {
      name: 'combo',
      path: '/combo.html',
      component: Combo,
      meta: {
        title: '高效脱单服务'
      }
    },
    {
      name: 'PersonInfo',
      path: '/info-:id.html',
      component: PersonInfo,
      meta: {
        scrollTop: true
      }
    },
    {
      name: 'ActivityInfo',
      path: '/activity-:id.html',
      component: ActivityInfo,
      meta: {
        scrollTop: true,
        isHideHeader: true,
      }
    },
    {
      name: 'Coin',
      path: '/coin.html',
      component: Coin,
      meta: {
        scrollTop: true,
        isHideHeader: true,
      }
    },
    {
      name: 'GapPrice',
      path: '/gapPrice.html',
      component: GapPrice,
      meta: {
        scrollTop: true,
        isHideHeader: true,
      }
    },
    {
      name: 'UserDeal',
      path: '/userDeal.html',
      component: UserDeal
    },
    {
      name: 'Agreement',
      path: '/agreement.html',
      component: Agreement
    },
    {
      name: 'AboutUs',
      path: '/aboutus.html',
      component: AboutUs
    },
    {
      name: 'Like',
      path: '/like.html',
      component: Like,
      meta: {
        title: '我喜欢的人',
        needLogin: true
      }
    },
    {
      name: 'LikeMe',
      path: '/likeme.html',
      component: LikeMe,
      meta: {
        title: '喜欢我的人',
        needLogin: true
      }
    },
    {
      name: 'Follow',
      path: '/follow.html',
      component: Follow,
      meta: {
        title: '我关注的人',
        needLogin: true
      }
    },
    {
      name: 'Ask',
      path: '/ask.html',
      component: Ask,
      meta: {
        hideTitle: true,
        needLogin: true
      }
    },
    {
      name: 'MessageDetail',
      path: '/message-detail-:id.html',
      component: MessageDetail
    },
    {
      name: 'Setting',
      path: '/setting.html',
      component: Setting,
      meta: {
        title: '设置'
      }
    },
    {
      name: 'CustomerService',
      path: '/customer-service.html',
      component: CustomerService,
      meta: {
        title: '客服'
      }
    },
    {
      name: 'SetUserData',
      path: '/setUserData',
      component: SetUserData,
      meta: {
        needLogin: true
      },
      children: [
        {
          name: 'SetSex',
          path: 'sex.html',
          component: SetSex,
          meta: {
            title: '选择性别'
          }
        },
        {
          name: 'SetEducation',
          path: 'education.html',
          component: SetEducation,
          meta: {
            title: '选择学历'
          }
        },
        {
          name: 'SetBirthday',
          path: 'birthday.html',
          component: SetBirthday,
          meta: {
            title: '选择生日'
          }
        },
        {
          name: 'SetTall',
          path: 'tall.html',
          component: SetTall,
          meta: {
            title: '选择身高'
          }
        },
        {
          name: 'SetPhone',
          path: 'phone.html',
          component: SetPhone,
          meta: {
            title: '手机绑定'
          }
        }
      ]
    },
    {
      name: 'BaseInfo',
      path: '/baseInfo.html',
      component: BaseInfo,
      meta: {
        title: '基础资料',
        needLogin: true
      }
    },
    {
      name: 'DisplayInfo',
      path: '/displayInfo.html',
      component: DisplayInfo,
      meta: {
        title: '基础资料',
        needLogin: true
      }
    },
    {
      name: 'Transcation',
      path: '/transcation.html',
      component: Transcation,
      meta: {
        title: '交易记录'
      }
    },
    {
      name: 'LikeDetail',
      path: '/likeDetail.html',
      component: LikeDetail,
      meta: {
        title: '“喜欢”明细'
      }
    },
    {
      name: 'UploadCert',
      path: '/upload-cert.html',
      component: UploadCert,
      meta: {
        title: '身份认证'
      }
    },
    {
      name: 'UploadEducation',
      path: '/upload-education.html',
      component: UploadEducation,
      meta: {
        title: '学历认证'
      }
    },
    {
      name: 'UploadCareer',
      path: '/upload-career.html',
      component: UploadCareer,
      meta: {
        title: '工作认证'
      }
    },
    {
      name: 'Test',
      path: '/test.html',
      component: Test,
      meta: {
        title: '测试cropper'
      }
    },
    {
      name: 'NotFound',
      path: '*',
      component: NotFound
    },
    {
      name: 'FakeIndex',
      path: '/index',
      component: FakeIndex,
      meta: {
        isHideHeader: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.name !== 'Coin' && to.name !== 'GapPrice') {
    next({
      path: '/coin.html'
    })
    return;
  }
  if (from.name) {
    Storage.save('referer', from.fullPath)
  } else if (!localStorage.getItem("isExit") && to.name !== 'Activity' && to.name !== 'ActivityInfo' && to.name !== 'Coin' && to.name !== 'GapPrice') {
    Storage.remove('referer')
    if (to.query.code) {
      // 获取到code后调用后台登录接口
      window.fetchingToken = true
      http('/api/login/wx/accesstoken', { code: to.query.code || '' }, 'get').then(res => {
        if (res.code === '0000') {
          store._mutations.updateUserData[0](res.data)
          let oldSession = store.getters.session
          let session = getCookie('session')
          if (oldSession != session) {
            store.commit('setSession', session)
          }
        } else {
          console.log(res)
        }
      })
    } else {
      let session = getCookie('session')
      if(!session) {
        window.initing = true
        wxApi.init({
          appid: process.env.VUE_APP_APP_ID, // 正式测试号
          redirectUri: window.location.href
        }).author(true)
      }
    }
  }
  // 记录当前页面滚动高度
  if (from.meta.scrollTop === false) {
    const scrollHeight = window.pageYOffset || document.documentElement.scrollTop
    from.meta.scrollHeight = scrollHeight
  }
  if (store.getters.userId) {
    if ((to.name === 'Account' || to.name === 'BaseInfo') && store.state.userData.status === 0) {
      next({
        path: '/setUserData/sex.html'
      })
    } else {
      next()
    }
  } else if (to.meta.needLogin && !getCookie('session')) {
    next({
      path: '/account.html',
      query: {
        direct: to.fullPath
      }
    })
  } else {
    if (!to.meta.needLogin && getCookie('session')) {
      store._actions.fetchUserData[0]()
      next()
    } else {
      store._actions.fetchUserData[0]().then(res => {
        if ((to.name === 'Account' || to.name === 'BaseInfo') && store.state.userData.status === 0) {
          next({
            path: '/setUserData/sex.html'
          })
        } else {
          next()
        }
      }, () => {
        if (from.name && from.name !== 'Account') {
          next({
            path: '/account.html',
            query: {
              direct: to.fullPath
            }
          })
        } else {
          next()
        }
      }).catch(err => {
        alert(err)
      })
    }
  }
})

export default router
